 
import { IOptionAnyValue } from 'bricks/types';
import { ProFormaModelIds } from 'constants/proForma';

export enum ColumnKeys {
    ANNUAL_GROWTH = 'annualGrowth',
    PERCENT_OF_EGR = 'percentOfEffectiveGrossRevenue',
    COST_PER_UNIT_PER_YEAR = 'costPerUnitPerYear',
    VALUE_PER_BED_PER_YEAR = 'valuePerBedPerYear',
    VALUE_PER_SF_PER_YEAR = 'valuePerSfPerYear',
    VALUE_PER_RACK_PER_YEAR = 'valuePerRackPerYear',
    VALUE_PER_KW_PER_YEAR = 'valuePerKwPerYear',
}

export const COLUMN_KEYS_BY_MODEL_ID: Record<string, ColumnKeys[]> = {
    [ProFormaModelIds.APARTMENT]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.COST_PER_UNIT_PER_YEAR,
    ],
    [ProFormaModelIds.RETAIL]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.VALUE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.OFFICE]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.VALUE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.INDUSTRIAL]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.VALUE_PER_SF_PER_YEAR,
    ],
    [ProFormaModelIds.DATA_CENTER]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.VALUE_PER_RACK_PER_YEAR,
        ColumnKeys.VALUE_PER_KW_PER_YEAR,
    ],
    [ProFormaModelIds.APARTMENT_WITH_RETAIL]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.COST_PER_UNIT_PER_YEAR,
    ],
    [ProFormaModelIds.STUDENT_HOUSING]: [
        ColumnKeys.ANNUAL_GROWTH,
        ColumnKeys.PERCENT_OF_EGR,
        ColumnKeys.VALUE_PER_BED_PER_YEAR,
    ],
};

export enum CAPITAL_RESERVES_OPTION_VALUES {
    OPEX = 'opex',
    CAPEX = 'capex',
}
export const CAPITAL_RESERVES_OPTIONS: IOptionAnyValue[] = [
    { value: CAPITAL_RESERVES_OPTION_VALUES.OPEX, label: 'Operating expenses' },
    { value: CAPITAL_RESERVES_OPTION_VALUES.CAPEX, label: 'Capital expenditures' },
];
